/**
 * Helpers de style partagés pour TOUS les sidebars (SideBarProf, SideBarChef,
 * SideBarProfCordo, Sidebar.jsx). Inspiré du design Tanoed (Page d'accueil
 * Anthropic) avec couleur d'accent bleu/cyan TanoEd.
 *
 * Style "active" :
 *   - Background dégradé bleu/cyan TanoEd, semi-transparent (~50%)
 *   - Texte blanc
 *   - Barre verticale blanche à gauche (indicateur d'état) via <ActiveBar />
 *   - Shadow douce
 *   - rounded-xl
 *
 * Style "hover" :
 *   - Fond slate translucide
 *   - Texte blanc
 */

export const ACTIVE_BG =
    'linear-gradient(135deg, rgba(59, 130, 246, 0.55) 0%, rgba(79, 172, 254, 0.45) 100%)';

/** Tailwind className helper pour un NavLink top-level. */
export const navItemClasses = ({ isActive }) =>
    `group relative w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200
     ${isActive
        ? 'text-white shadow-lg shadow-blue-900/30'
        : 'text-slate-300 hover:text-white hover:bg-slate-800/50'}`;

/** Tailwind className helper pour un NavLink de sous-menu (légèrement plus petit). */
export const subNavItemClasses = ({ isActive }) =>
    `group relative w-full flex items-center gap-2 px-3 py-2 rounded-xl text-left transition-all duration-200
     ${isActive
        ? 'text-white shadow-md shadow-blue-900/20'
        : 'text-slate-300 hover:text-white hover:bg-slate-800/50'}`;

/** Style inline pour appliquer le fond dégradé sur l'élément actif. */
export const navItemStyle = ({ isActive }) =>
    isActive ? { background: ACTIVE_BG } : undefined;

/** Style pour un toggle button (menu déroulant) selon l'état ouvert. */
export const toggleButtonClasses = (isOpen) =>
    `group relative w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200
     ${isOpen ? 'text-white bg-slate-800/40' : 'text-slate-300 hover:text-white hover:bg-slate-800/50'}`;

/** Petite barre verticale blanche à gauche pour signaler l'état actif. */
export const ActiveBar = () => (
    <span className="absolute -left-1 top-1/2 -translate-y-1/2 w-1 h-6 rounded-r-full bg-white/90" />
);

/** Helper pour les classes d'icône selon l'état actif. */
export const iconClasses = (isActive) =>
    `shrink-0 ${isActive ? 'text-white' : 'text-slate-400 group-hover:text-white'}`;
